import {Component, Input, Output, EventEmitter, OnDestroy, OnInit} from '@angular/core';
import {MatDialog, MatSliderChange, MatSnackBar} from '@angular/material';
import {ActivatedRoute, Router} from '@angular/router';
import {MapTab, MapComponent, ClickDisplay} from '../../map.component'
import {
  FourDService,
  Annotation
} from '4d-mapper'

import {MapService} from '../../../../commons/map.service';
import {AppService} from '../../../../commons/app.service';
import {BaseComponent} from '../../../../commons/BaseComponent';
import { Subscription } from 'rxjs';
import { InspectionComponent } from '../inspect.component';
import { APITypes } from '../../../../commons/global';
import {EntityHelperService} from '../../../../service/entity-helper.service';
import { XsApplicationEventsService } from '../../../../xs/services/events/application-events.service';

const Cesium = (<any>window).Cesium;

@Component({
  selector: 'agro-list-comp',
  templateUrl: './agro.component.html',
  styleUrls: ['./agro.component.scss','../../map_commons.scss']
})
export class AgroListComponent extends BaseComponent implements OnInit, OnDestroy, MapTab{

  sensors:Annotation[]
  stations:Annotation[]
  checkAllOpts:any = {}
  plots:{} = {}
  
  allAnnots:Annotation[]
  constructor(private route: ActivatedRoute, public router: Router, private fourD: FourDService, snackBar: MatSnackBar, dialog: MatDialog, 
    public entityHelper:EntityHelperService, public mapService: MapService, public service: AppService, applicationEvents:XsApplicationEventsService) {
    super(router, snackBar, dialog)
    console.log ( 'agro.component CONSTRUCTOR', this);
  }

  init() {
    
    this.addSubscription( 'onAnnotationsChange', this.mapService.onAnnotationsChange().subscribe(s => {
      
      var agros = this.mapService.annotations.filter(a => a['annotationMode'] == 'agronomeye')


      this.sensors = agros.filter(a => a['category'] == 'sensors')
      this.stations = agros.filter(a => a['category'] == 'weatherStations')
      this.allAnnots = agros
      agros.forEach(a => this.plots['' + a.id] = true)
      this.checkAllOpts = {
        weatherStations:true,
        sensors:true
      }
    }))

  }
  
  clickedMap(movement, rightClick:boolean, checkedPosition):ClickDisplay{
    console.log ( 'agro.comp :: clickedMap()');
    var feature = this.mapService.viewer.scene.pick(movement.position);
    var def = Cesium.defined(feature);
    if (def && !feature.content && feature.id.fourd_ref) {
      var newSelect = this.mapService.annotations.find(a => a.id == feature.id.fourd_ref)
      this.mapComp.inspectorComp.setSelected(newSelect)
    }
    else{
      // if details tab is open....
      if(this.mapComp.detailsNav.opened && rightClick){
        this.mapComp.inspectorComp.setSelected(null,false)
        this.router.navigate([this.fourD.activeUser?'/app/projects/map':'/map',this.mapService.currentProject.id,'agro'])
      }
      else{
        this.mapComp.inspectorComp.setSelected(null,false)
        if(!rightClick){
          this.router.navigate([
            this.fourD.activeUser?'/app/projects/map':'/map',
            this.mapService.currentProject.id,'geojson',
            Cesium.Math.toDegrees(this.mapComp.currentCoord.position.latitude),
            Cesium.Math.toDegrees(this.mapComp.currentCoord.position.longitude)
          ])
          return ClickDisplay.Chevron
        }
      }
    }
  }

  agroToggle(a:Annotation){
    this.mapComp.detailsNav.close()
    if(this.plots['' + a.id])
      this.mapService.helper.addPlottable(a).subscribe(res =>
        res.object.pin.billboard.image = this.entityHelper.getPinImage(res.plottable)
      )
    else
      this.mapService.helper.removePlottable(a)
      
  }
  private mapComp:MapComponent
  becameActive(mapComp:MapComponent){
    this.mapComp = mapComp

    var agros = this.mapService.annotations.filter(a => a['annotationMode'] == 'agronomeye')
    agros.forEach(a => this.agroToggle(a))
  }
  becameInactive(mapComp:MapComponent){

    var agros = this.mapService.annotations.filter(a => a['annotationMode'] == 'agronomeye')
    agros.forEach(a => this.mapService.helper.removePlottable(a))
  }

  refreshSensors(){
    var apiType = this.mapService.fourD.apis.find(a => a.processorImpl == APITypes.Agronomeye.IMPL)

    apiType.saveObservable().subscribe(_ =>
      this.fourD.V.api('/remote/' + apiType.id + '/test').subscribe(s => {
        this.mapService.refreshAnnotations().subscribe( s => 
          this.openSnackBarSuccess('MAP.SYNC_MSG')
        )
          
      },e =>

          this.openSnackBarError('GENERIC.CONNECT_ERROR2'+ e)
      )
  )
  }

  checkAll(s:string){
    this.checkAllOpts[s] = !this.checkAllOpts[s]
    if(this.checkAllOpts[s]){
      this.allAnnots.filter(a => a['category'] == s).forEach(a =>   this.mapService.helper.addPlottable(a).subscribe(res =>
        res.object.pin.billboard.image = this.entityHelper.getPinImage(res.plottable)
      ))
    }
    else{
      this.allAnnots.filter(a => a['category'] == s).forEach(a =>   this.mapService.helper.removePlottable(a))
    }
  }
}

